const formatAmount_: Intl.NumberFormat = Intl.NumberFormat('da-DK', {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

const formatNumber_: Intl.NumberFormat = Intl.NumberFormat('da-DK', {
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
});

export const formatNumber = (num: number): string => {
	return isNaN(num) ? undefined : formatNumber_.format(num);
};

export const formatAmount = (num: number): string => {
	return isNaN(num) ? undefined : formatAmount_.format(num);
};

// Accepts Danish-authored amounts
// Returns NaN for anything that isn't a number-shaped string; callers decide the fallback.
export const parseDanishAmount = (raw: unknown): number => {
	if (typeof raw !== 'string') return typeof raw === 'number' ? raw : Number.NaN;
	const cleaned = raw
		.trim()
		.replace(/kr\.?$/i, '')
		.replace(/\s/g, '');
	if (!cleaned) return Number.NaN;
	const normalized = cleaned.includes(',')
		? cleaned.replace(/\./g, '').replace(',', '.')
		: cleaned.replace(/\./g, '');
	if (!/^[+-]?\d+(?:\.\d+)?$/.test(normalized)) return Number.NaN;
	return Number(normalized);
};

export const formatDkDate = (date = new Date()) => {
	const dateFormatter = Intl.DateTimeFormat('da-DK', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	});

	return dateFormatter.format(date).replaceAll('.', '-');
};

export const formatShortIsoDate = (date = new Date()) => {
	return date.toISOString().split('T')[0];
};

/**
 * Method for calculating users birth date from entered age.
 * so approximate: today − age (years) - 1 day.
 */
export const computeBirthdateFromAge = (age: number, today = new Date()): string | undefined => {
	if (!Number.isFinite(age) || age < 0) return undefined;
	const d = new Date(today);
	d.setUTCFullYear(d.getUTCFullYear() - age);
	d.setUTCDate(d.getUTCDate() - 1);
	return formatShortIsoDate(d);
};
